import { appMethod as app, appInstance } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import utils from '@utils/util';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GpOrderDetail.less';

export default class GpOrderDetail extends OfficialPage {
  state = {
    page: 1,
    myTeams: {},
    formid: [],
    hasAdditionalInfo: false,
    coverList: [],
    goodsData: {
      goods_list: [],
      is_more: 1,
      curpage: 1,
      loading: false,
      loadingFail: false
    },
    orderId: '',
    status: 4,
    teamToken: '',
    needNum: 0,
    progress: 0,
    modelId: 0,
    storeStyle: {}
  }
  seckillFunc = []
  isMore = 1
  page = 1

  constructor(props) {
    super(props);
    document.title = '拼团订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      team_token: options.teamtoken,
      franchiseeId: options.franchisee || ''
    })
    this.pageInit()
  }

  pageInit = () => {
    var _this = this
    if (app.isLogin()) {
      _this.loadAll()
    } else {
      app.goLogin({
        success: function () {
          _this.loadAll()
        }
      })
    }
  }
  loadAll = () => {
    var _this = this
    _this.loadMyTeams()
    this.setData({
      appName: app.globalData.appTitle,
      appLogo: app.globalData.appLogo
    })
  }
  loadMyTeams = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/teamInfo',
      data: {
        team_token: _this.data.team_token
      },
      success: res => {
        var coverList = [],
          myTeams = res.data,
          modelId = myTeams.model_id || '',
          coverObj = {},
          orderInfo = myTeams.order_info || '',
          goodsDetail = orderInfo.goods_info[0],
          orderId = orderInfo.order_id,
          progress = parseInt(
            Number(res.data.current_user_count / res.data.max_user_num) * 100
          ),
          maxNum = Number(myTeams.max_user_num) || 0,
          needNum = maxNum - myTeams.current_user_count || '',
          hasAdditionalInfo = false,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          originPrice =
            myTeams.virtual_price == '0.00'
              ? myTeams.goods_price
              : myTeams.virtual_price
        myTeams.downCount = {
          hours: '00',
          minutes: '00',
          seconds: '00',
          days: '00'
        }
        if (orderInfo.additional_info) {
          for (var i = 0; i < orderInfo.goods_info.length; i++) {
            var deliveryId = orderInfo.goods_info[i].delivery_id,
              goodsId = orderInfo.goods_info[i].goods_id
            if (
              deliveryId &&
              deliveryId != '0' &&
              additional_goodsid_arr.indexOf(goodsId) == -1
            ) {
              additional_info_goods.push(orderInfo.goods_info[i])
              additional_goodsid_arr.push(goodsId)
              hasAdditionalInfo = true
            }
          }
        }
        if (myTeams.member) {
          var coverTotalArr = myTeams.member || '',
            coverArr = [],
            numLack =
              myTeams.activity_type == 3
                ? maxNum - coverTotalArr.length + 1
                : maxNum - coverTotalArr.length,
            numLen = 0,
            coverLoading = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/loading-portrait.png'
            },
            coverUser = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png'
            },
            coverSuccess = {
              isNum: 0,
              image:
                'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/success-loading.png'
            }
          for (let arrIndex in coverTotalArr) {
            coverObj = {
              isNum: 1,
              image: coverTotalArr[arrIndex]
            }
            coverArr.push(coverObj)
          }
          if (maxNum > 5) {
            switch (coverArr.length) {
              case 1:
                numLen = 2
                break
              case 2:
                numLen = 1
                break
              case 3:
                numLen = 0
                break
            }
            if (coverArr.length < 3) {
              //显示3个用户+1个等待+1个用户
              coverList = coverArr
              for (var i = 0; i < numLen; i++) {
                coverList.push(coverUser)
              }
              coverList.push(coverLoading)
              coverList.push(coverUser)
            } else if (coverArr.length >= 3 && coverArr.length < 5) {
              for (var index in coverArr) {
                if (index < 3) {
                  coverList.push(coverArr[index])
                }
              }
              coverList.push(coverLoading)
              coverList.push(coverUser)
            } else if (coverArr.length >= 5) {
              if (coverArr.length < maxNum) {
                for (var index in coverArr) {
                  if (index < 3) {
                    coverList.push(coverArr[index])
                  }
                }
                coverList.push(coverLoading)
                coverList.push(coverUser)
              } else {
                for (var index in coverArr) {
                  if (index < 4) {
                    coverList.push(coverArr[index])
                  }
                }
                coverList.push(coverSuccess)
              }
            }
          } else {
            coverList = coverArr
            for (let i = 0; i < numLack; i++) {
              coverList.push(coverUser)
            }
          }
        }
        myTeams.server_time = res.current_time
        myTeams.seckill_end_time = utils.formatTime(
          new Date(myTeams.expired_time * 1000)
        )
        if (myTeams.current_status == 0 || myTeams.current_status == 1) {
          _this.downcount = _this.beforeGroupDownCount(
            myTeams,
            _this,
            'myTeams'
          )
        } else if (myTeams.current_status == 2) {
          _this.downcount = _this.duringGroupDownCount(
            myTeams,
            _this,
            'myTeams'
          )
        }
        if (myTeams.parent_shop_app_id) {
          _this.setData({
            appId: myTeams.parent_shop_app_id,
            franchiseeId: myTeams.app_id
          })
        }
        app.setPreviewGoodsInfo(additional_info_goods)
        app.setGoodsAdditionalInfo(orderInfo.additional_info || {})
        _this.setData({
          progress: progress,
          myTeams: myTeams,
          modelId: modelId,
          hasAdditionalInfo: hasAdditionalInfo,
          orderId: orderId,
          originPrice: originPrice,
          goodsId: myTeams.goods_id,
          activityId: myTeams.activity_id,
          team_token: orderInfo.team_token,
          member: coverList,
          goodsDetail: orderInfo.goods_info[0],
          needNum: needNum
        })
        _this.loadList()
      }
    })
  }
  seeAdditionalInfo = () => {
    app.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo')
  }
  beforeGroupDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.status'] = 3
          newData[path + '.current_status'] = 3
          newData[path + '.server_time'] = formData.seckill_start_time
          page.setData(newData)
          formData.server_time = formData.seckill_start_time
          _this.downcount = _this.duringGroupDownCount(formData, page, path)
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  duringGroupDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function () {
          let newData = {}
          newData[path + '.status'] = 4
          newData[path + '.current_status'] = 4
          page.setData(newData)
          if (path == 'myTeams') {
            page.loadMyTeams()
          }
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  loadList = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/goodsList',
      data: {
        page: _this.page,
        page_size: 4,
        status: 1,
        app_id: _this.data.appId || '',
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      success: res => {
        let rdata = res.data,
          newdata = {},
          compid = 'goodsData',
          goodsList = this.data.goodsData.goods_list,
          length = goodsList.length,
          downcountArr = _this.downcountArr || []
        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i]
          f.description = ''
          f.original_price =
            f.virtual_price == '0.00' ? f.original_price : f.virtual_price
        }
        var dataArr = res.data
        newdata[compid + '.goods_list'] = goodsList.concat(dataArr)
        newdata[compid + '.is_more'] = res.is_more
        newdata[compid + '.curpage'] = 1
        newdata[compid + '.loading'] = false
        newdata[compid + '.loadingFail'] = false
        _this.downcountArr = downcountArr
        _this.setData(newdata)
        _this.page++
        _this.isMore = res.is_more
      }
    })
  }
  gotoDetail = e => {
    var _this = this,
      data = e.currentTarget.dataset,
      pageUrl =
        '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
        data.goodsid +
        '&activity_id=' +
        data.activityid +
        (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pageUrl)
    })
  }
  copyOrderId = () => {
    let _this = this
    app.setClipboardData({
      data: _this.data.team_token,
      success: function (res) {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  openNewGroup = () => {
    let myTeams = this.data.myTeams
    if (myTeams.enable_status == '0') {
      app.turnToPage(
        '/pages/goodsDetail/goodsDetail?detail=' +
        myTeams.goods_id +
        (this.data.franchiseeId
          ? '&franchisee=' + this.data.franchiseeId
          : '')
      )
      return
    }
    var pathUrl =
      '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
      this.data.myTeams.goods_id +
      '&activity_id=' +
      this.data.myTeams.activity_id +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pathUrl)
    })
  }
  showMyTeamList = () => {
    this.saveUserFormId(function () {
      app.turnToPage(
        '/group/pages/gpmyOrder/gpmyOrder' +
        (this.data.franchiseeId
          ? '&franchisee=' + this.data.franchiseeId
          : '')
      )
    })
  }
  inviteFriends = () => {
    let that = this
    let myTeams = this.data.myTeams
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/getShareQRCode',
      data: {
        goods_id: myTeams.goods_id,
        activity_id: myTeams.activity_id,
        type: 6,
        text: myTeams.goods_title,
        price: myTeams.group_buy_price,
        virtual_price: that.data.originPrice,
        goods_img: myTeams.img_urls ? myTeams.img_urls[0] : myTeams.goods_cover,
        app_id: that.data.appId || '',
        sub_shop_app_id: that.data.franchiseeId || '',
        user_token: app.globalData.PromotionUserToken || '',
        team_token: myTeams.order_info.team_token,
        order_id: myTeams.order_info.order_id
      },
      success: function (res) {
        // animation.bottom('0').step()
        // that.setData({
        //   'pageQRCodeData.shareDialogShow': 0,
        //   'pageQRCodeData.shareMenuShow': true,
        //   'pageQRCodeData.goodsInfo': res.data,
        //   'pageQRCodeData.animation': animation.export()
        // })
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data,
          },
        });
      }
    })
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        form_id: _this.data.formid || [],
        app_id: _this.data.appId || '',
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      complete: function () {
        app.hideLoading()
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }
  gotoOrderDetail = () => {
    var pageUrl =
      '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' +
      this.data.orderId +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    app.turnToPage(pageUrl)
  }
  goDeliveryNavigation = () => {
    app.openLocation({
      latitude: Number(
        this.data.myTeams.order_info.self_delivery_info.latitude
      ),
      longitude: Number(
        this.data.myTeams.order_info.self_delivery_info.longitude
      ),
      name: this.data.myTeams.order_info.self_delivery_info.address
    })
  }

  componentDidMount() { }

  componentDidShow() { }

  componentDidHide() { }

  componentWillUnmount() {
    if (this.downcount) {
      this.downcount.clear()
    }
  }

  onPullDownRefresh = () => { }
  onReachBottom = () => {
    if (this.isMore) {
      this.loadList()
    }
  }
  onShareAppMessage = () => {
    var that = this,
      team_token = this.data.team_token,
      myTeams = this.data.myTeams,
      type = myTeams.activity_type,
      modelId = this.data.modelId,
      urlPromotion = app.globalData.PromotionUserToken
        ? '&user_token=' + app.globalData.PromotionUserToken
        : '',
      franchiseeParam = this.data.franchiseeId
        ? '&franchisee=' + this.data.franchiseeId
        : '',
      url =
        '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' +
        team_token +
        '&orderId=' +
        that.data.orderId +
        franchiseeParam,
      nickname = app.getUserInfo('nickname'),
      share_cover = myTeams.share_cover
        ? myTeams.share_cover
        : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
      title = myTeams.share_title
        ? myTeams.share_title
        : (nickname ? nickname + ' 喊你' : '') +
        '拼单啦~ ' +
        that.data.myTeams.group_buy_price +
        '元拼' +
        that.data.myTeams.goods_title +
        '，火爆抢购中......'
    return app.shareAppMessage({
      title: title,
      path: url,
      imageUrl: share_cover,
      success: function (addTime) {
        app.showToast({
          title: '转发成功',
          duration: 500
        })
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: {
            add_time: addTime,
            app_id: that.data.appId || '',
            sub_shop_app_id: that.data.franchiseeId || ''
          },
          success: function (res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      }
    })
  }

  scrollAllowBottom = true;
  onPageScroll = (e) => {
    let officialPageDom = this.officialPageRef.current;
    e = {
      ...e,
      scrollTop: officialPageDom.scrollTop,
      scrollLeft: officialPageDom.scrollLeft,
      scrollWidth: officialPageDom.scrollWidth,
      scrollHeight: officialPageDom.scrollHeight,
    }
    if ((officialPageDom.scrollTop + officialPageDom.clientHeight >= officialPageDom.scrollHeight - 100) && this.scrollAllowBottom) {
      this.scrollAllowBottom = false;
      this.onReachBottom()
    } else if (officialPageDom.scrollTop + officialPageDom.clientHeight < officialPageDom.scrollHeight - 100) {
      this.scrollAllowBottom = true;
    }
  }

  render() {
    const {
      showGetUserInfo,
      pageQRCodeData,
      myTeams,
      goodsDetail,
      originPrice,
      needNum,
      member,
      goodsInfo,
      progress,
      appLogo,
      appName,
      storeStyle,
      hasAdditionalInfo,
      team_token,
      goodsData
    } = this.state
    return (
      <div ref={this.officialPageRef} className='official-page gp-order-detail' onScroll={this.onPageScroll}>
        <TopNav title="拼团订单详情" />
        <div className="collage-orderInfo">
          <div className="collage-section goods-infor">
            <div className="goods-detail">
              <div className="image-wrap">
                <img src={myTeams.goods_cover} />
              </div>
              <div className="content-wrap">
                <div className="title">
                  <div className="classify-type">
                    <div>
                      <i className="ico-moon icon-number-people"></i>
                    </div>
                    <span>
                      {myTeams.activity_type == 0
                        ? myTeams.max_user_num + '人团'
                        : myTeams.activity_type == 1
                          ? '新人团'
                          : myTeams.activity_type == 2
                            ? '阶梯团'
                            : myTeams.activity_type == 3
                              ? '帮帮团'
                              : '抽奖团'}
                    </span>
                  </div>
                  {goodsDetail && goodsDetail.goods_name}
                </div>
                <div className="price">
                  <span className="min-price">
                    ¥<span>{myTeams.group_buy_price}</span>
                  </span>
                  <span className="origin-price">{'¥' + originPrice}</span>
                </div>
                <div className="num">
                  {'已团' + myTeams.goods_count + '件'}
                </div>
              </div>
            </div>
          </div>
          <div className="collage-section collage-infor">
            {myTeams.activity_type != 4 ? (
              <React.Fragment>
                {myTeams.current_status == 2 && (
                  <div className="loading-stand">
                    <div className="tip">
                      <div>
                        {myTeams.activity_type != '2' ? (
                          <React.Fragment>
                            还差
                            <span className="needNum">{needNum + '人'}</span>
                            拼购成功, 剩余
                          </React.Fragment>
                        ) : (
                            <React.Fragment>人数越多, 价格越低, 剩余</React.Fragment>
                          )}
                      </div>
                      <div className="countDown">
                        {(myTeams.downCount.days != '00' ||
                          myTeams.downCount.days != '0') && (
                            <React.Fragment>
                              <span>{myTeams.downCount.days}</span>
                              <span>天</span>
                            </React.Fragment>
                          )}
                        <span>{myTeams.downCount.hours}</span>
                        <span>:</span>
                        <span style={convertLineStyleData('width:48rpx;')}>
                          {myTeams.downCount.minutes}
                        </span>
                        <span>:</span>
                        <span style={convertLineStyleData('width:48rpx;')}>
                          {myTeams.downCount.seconds}
                        </span>
                      </div>
                    </div>
                    <div className="member-cover">
                      {member.map((item, index) => {
                        return (
                          <div key={index}>
                            <img
                              src={item.image}
                              style={convertLineStyleData(
                                'border: ' +
                                (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                              )}
                            />
                            {index == 0 && (
                              <div className="leader-logo">团长</div>
                            )}
                          </div>
                        )
                      })}
                    </div>
                    <div className="btn-wrap">
                      <div
                        className="open-new  isRelative"
                        onClick={this.inviteFriends}
                      >
                        邀请好友参团
                      </div>
                    </div>
                  </div>
                )}
                {myTeams.current_status == 3 && (
                  <div className="success-stand">
                    <div className="tip">
                      {myTeams.activity_type == 3 ? (
                        <React.Fragment>
                          <span style={convertLineStyleData('color:#ff7100;')}>拼团成功，</span>
                          商家将给团长发货
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            <span style={convertLineStyleData('color:#ff7100;')}>拼团成功，</span>
                            请耐心等待商家发货
                        </React.Fragment>
                        )}
                    </div>
                    <div className="member-cover">
                      {member.map((item, index) => {
                        return (
                          <div key={index}>
                            <img
                              src={item.image}
                              style={convertLineStyleData(
                                'border: ' +
                                (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                              )}
                            />
                            {index == 0 && (
                              <div className="leader-logo">团长</div>
                            )}
                          </div>
                        )
                      })}
                    </div>
                    <div className="btn-wrap">
                      <div
                        className="open-new isRelative"
                        onClick={this.openNewGroup}
                      >
                        开启新团
                      </div>
                    </div>
                  </div>
                )}
                {(myTeams.current_status == 4 ||
                  myTeams.current_status == 5) && (
                    <div className="fail-stand">
                      <div className="tip">来迟一步，这个团已经拼完啦～</div>
                      <div className="member-cover">
                        {member.map((item, index) => {
                          return (
                            <div key={index}>
                              <img
                                src={item.image}
                                style={convertLineStyleData(
                                  'border: ' +
                                  (item.isNum == 1 ? '2rpx solid #ff7100' : '')
                                )}
                              />
                              {index == 0 && (
                                <div className="leader-logo">团长</div>
                              )}
                            </div>
                          )
                        })}
                      </div>
                      <div className="btn-wrap">
                        <div
                          className="open-new isRelative"
                          onClick={this.openNewGroup}
                        >
                          开启新团
                        </div>
                      </div>
                    </div>
                  )}
              </React.Fragment>
            ) : (
                <React.Fragment>
                  {myTeams.current_status == 2 && (
                    <div className="loading-draw">
                      <div className="progress">
                        <div
                          className="success"
                          style={convertLineStyleData('width:' + progress + '%;')}
                        >
                          <div className="inner">
                            {'已抢' + myTeams.current_user_count + '件'}
                          </div>
                        </div>
                        <div className="percent">{progress + '%'}</div>
                      </div>
                      <div className="tip">
                        <div>
                          已有
                        <span className="needNum">
                            {myTeams.current_user_count}
                          </span>
                          {'人参与，满' +
                            myTeams.max_user_num +
                            '人开奖，快去邀请小伙伴吧～'}
                        </div>
                        <div>
                          剩余
                        <div className="countDown">
                            {(myTeams.downCount.days != '00' ||
                              myTeams.downCount.days != '0') && (
                                <React.Fragment>
                                  <span>{myTeams.downCount.days}</span>
                                  <span>天</span>
                                </React.Fragment>
                              )}
                            <span>{myTeams.downCount.hours}</span>
                            <span>:</span>
                            <span style={convertLineStyleData('width:48rpx;')}>
                              {myTeams.downCount.minutes}
                            </span>
                            <span>:</span>
                            <span style={convertLineStyleData('width:48rpx;')}>
                              {myTeams.downCount.seconds}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="btn-wrap">
                        <div
                          className="open-new isRelative"
                          onClick={this.inviteFriends}
                        >
                          邀请好友
                        </div>
                      </div>
                    </div>
                  )}
                  {myTeams.current_status == 3 && myTeams.is_winner == 1 && (
                    <div className="success-draw">
                      <div className="tip">
                        <div>
                          运气爆棚！<span>中奖啦</span>～
                      </div>
                      </div>
                      <div className="member-cover">
                        <div>
                          <img
                            src={myTeams.winner}
                            style={convertLineStyleData('border: 2rpx solid #ff7100')}
                          />
                        </div>
                      </div>
                      <div className="btn-wrap" onClick={this.gotoOrderDetail}>
                        <div className="open-new">查看订单</div>
                      </div>
                    </div>
                  )}
                  {(myTeams.current_status == 4 ||
                    myTeams.current_status == 5 ||
                    myTeams.is_winner == 0) && (
                      <div className="loading-draw">
                        <div className="tip">
                          {myTeams.is_winner == 0 ? (
                            <React.Fragment>很遗憾，您未中奖</React.Fragment>
                          ) : (
                              <React.Fragment>很遗憾，本次活动未达到开奖门槛</React.Fragment>
                            )}
                        </div>
                        <div
                          className="member-cover"
                          style={convertLineStyleData('padding:40rpx 0 50rpx;margin:0 auto;width:165rpx;height:165rpx;')}
                        >
                          <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/draw-fail.png" />
                        </div>
                      </div>
                    )}
                </React.Fragment>
              )}
          </div>
          {(myTeams.activity_type != 4 ||
            (myTeams.activity_type == 4 &&
              myTeams.current_status == 3 &&
              myTeams.is_winner == 1)) && (
              <div className="collage-section detail-infor">
                <div className="mutual-infor">
                  <div className="custom">
                    <div className="app-box">
                      <img className="app-logo" src={appLogo} />
                      <span className="app-name">{appName}</span>
                    </div>
                    <div className="goods-opt-item">
                      {/* TODO <ContactButton
                        type="default-dark"
                        size="20"
                        sessionFrom="goodsDetail"
                        className="contact"
                      ></ContactButton> */}
                      <div>联系客服</div>
                    </div>
                  </div>
                  <div className="buyer-information">
                    <span className="ico-moon icon-goods-location"></span>
                    {myTeams.order_info && myTeams.order_info.pick_up_type == 1 && (
                      <React.Fragment>
                        <div className="buyer-box">
                          <div className="buyer-name-box">
                            <span
                              className="cash-delivery shipping-type"
                              style={convertLineStyleData('background:' + storeStyle.theme)}
                            >
                              快递
                          </span>
                            {myTeams.order_info.is_pay_on_delivery == 1 && (
                              <span
                                className="cash-delivery"
                                style={convertLineStyleData('background:' + storeStyle.theme)}
                              >
                                到付
                            </span>
                            )}
                            <span className="buyer-name">
                              {myTeams.order_info.address_info.name}
                            </span>
                            <span>{myTeams.order_info.address_info.contact}</span>
                          </div>
                          <div className="buyer-address">
                            {myTeams.order_info.address_info.province.text +
                              myTeams.order_info.address_info.city.text +
                              myTeams.order_info.address_info.district.text +
                              myTeams.order_info.address_info.detailAddress}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {myTeams.order_info && myTeams.order_info.pick_up_type == 2 ? (
                      <React.Fragment>
                        <div className="buyer-box">
                          <div className="buyer-name-box">
                            <span
                              className="cash-delivery shipping-type"
                              style={convertLineStyleData('background:' + storeStyle.theme)}
                            >
                              同城
                          </span>
                            {myTeams.order_info.is_pay_on_delivery == 1 && (
                              <span
                                className="cash-delivery"
                                style={convertLineStyleData('background:' + storeStyle.theme)}
                              >
                                到付
                            </span>
                            )}
                            <span className="buyer-name">
                              {myTeams.order_info.address_info.name}
                            </span>
                            <span>{myTeams.order_info.address_info.contact}</span>
                          </div>
                          <div className="buyer-address">
                            {myTeams.order_info.address_info.province.text +
                              myTeams.order_info.address_info.city.text +
                              myTeams.order_info.address_info.district.text +
                              myTeams.order_info.address_info.detailAddress}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                        myTeams.order_info && myTeams.order_info.pick_up_type == 3 && (
                          <React.Fragment>
                            <div className="buyer-box">
                              <div className="buyer-name-box">
                                <span
                                  className="cash-delivery shipping-type"
                                  style={convertLineStyleData('background:' + storeStyle.theme)}
                                >
                                  自提
                            </span>
                                {myTeams.order_info.is_pay_on_delivery == 1 && (
                                  <span
                                    className="cash-delivery"
                                    style={convertLineStyleData('background:' + storeStyle.theme)}
                                  >
                                    到付
                              </span>
                                )}
                                <span className="buyer-name">
                                  {
                                    myTeams.order_info.self_delivery_info
                                      .contact_name
                                  }
                                </span>
                                <span>
                                  {
                                    myTeams.order_info.self_delivery_info
                                      .contact_phone
                                  }
                                </span>
                              </div>
                              <div className="buyer-address">
                                {myTeams.order_info.self_delivery_info.address}
                              </div>
                            </div>
                            <div
                              className="delivery-navigation"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                              onClick={this.goDeliveryNavigation}
                            >
                              导航
                        </div>
                          </React.Fragment>
                        )
                      )}
                  </div>
                </div>
                <div className="price-statis">
                  <div className="incidental-pay">
                    <div>
                      <span className="name">商品拼团价</span>
                      <span className="price">
                        {'¥' + (myTeams.order_info ? myTeams.order_info.original_price : '')}
                      </span>
                    </div>
                    <div>
                      <span className="name">优惠抵扣</span>
                      <div className="price">
                        <div>
                          {
                            myTeams.order_info && myTeams.order_info.selected_benefit_info && myTeams.order_info.selected_benefit_info.discount_title
                          }
                        </div>
                        <div>{'¥' + (myTeams.order_info ? myTeams.order_info.discount_cut_price : '')}</div>
                      </div>
                    </div>
                    {myTeams.order_info && myTeams.order_info.box_fee != 0 && (
                      <div>
                        <span className="name">餐盒费</span>
                        <span className="price">
                          {'¥' + myTeams.order_info.box_fee}
                        </span>
                      </div>
                    )}
                    <div>
                      <span className="name">运费</span>
                      <span className="price">
                        {'¥' + (myTeams.order_info ? myTeams.order_info.express_fee : '')}
                      </span>
                    </div>
                    <div>
                      <span className="name">订单总价</span>
                      <span className="price">
                        {'¥' + (myTeams.order_info ? myTeams.order_info.order_total_price : '')}
                      </span>
                    </div>
                    {myTeams.order_info && myTeams.order_info.settlement_activity &&
                      myTeams.order_info.settlement_activity
                        .discount_cut_price && (
                        <div>
                          <span className="name">支付有礼</span>
                          <span className="price">
                            {'-¥' +
                              myTeams.order_info.settlement_activity
                                .discount_cut_price}
                          </span>
                        </div>
                      )}
                    <div>
                      <span className="name">储值抵扣</span>
                      <span className="price">
                        {'-¥' + (myTeams.order_info ? myTeams.order_info.use_balance : '')}
                      </span>
                    </div>
                  </div>
                  <div className="actual-pay">
                    <span>实际付款</span>
                    <span className="price">
                      {'¥' + (myTeams.order_info ? myTeams.order_info.total_price : '')}
                    </span>
                  </div>
                </div>
                <div className="custom-remark">
                  <span className="name">买家留言</span>
                  <span className="remark">{myTeams.order_info && myTeams.order_info.remark}</span>
                </div>
                {hasAdditionalInfo && (
                  <div
                    className="addition-info"
                    onClick={this.seeAdditionalInfo}
                  >
                    <div>
                      <span>补充信息</span>
                      <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
                    </div>
                  </div>
                )}
                <div className="list-infor">
                  {myTeams.activity_type != 4 ? (
                    <React.Fragment>
                      <div className="hasBtn">
                        <div>
                          <div className="name">团号</div>
                          <div className="msg">{team_token}</div>
                        </div>
                        <div
                          className="copy-btn isRelative"
                          onClick={this.copyOrderId}
                        >
                          复制
                        </div>
                      </div>
                      <div>
                        <div className="name">下单时间</div>
                        <div className="msg">{myTeams.order_info && myTeams.order_info.add_time}</div>
                      </div>
                      {myTeams.current_status == 3 && (
                        <div>
                          <div className="name">成团时间</div>
                          <div className="msg">{myTeams.success_time}</div>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        <div className="hasBtn">
                          <div>
                            <div className="name">下单时间</div>
                            <div className="msg">
                              {myTeams.order_info.add_time}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="name">开奖时间</div>
                          <div className="msg">{myTeams.seckill_end_time}</div>
                        </div>
                      </React.Fragment>
                    )}
                  {myTeams.order_info && myTeams.order_info.ecommerce_info.dispatch_use_pick_up_type ==
                    2 ? (
                      <React.Fragment>
                        <div>
                          <div className="name">到达时间</div>
                          <div className="price">
                            {
                              myTeams.order_info.ecommerce_info.intra_city_data
                                .intra_city_appointment_arrive_time
                            }
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      myTeams.order_info && myTeams.order_info.ecommerce_info.dispatch_use_pick_up_type ==
                      3 && (
                        <React.Fragment>
                          <div>
                            <div className="name">取货时间</div>
                            <div className="price">
                              {
                                myTeams.order_info.ecommerce_info.ec_tostore_data
                                  .ec_tostore_appointment_time
                              }
                            </div>
                          </div>
                          <div>
                            <div className="name">手机号码</div>
                            <div className="price">
                              {
                                myTeams.order_info.ecommerce_info.ec_tostore_data
                                  .ec_tostore_buyer_phone
                              }
                            </div>
                          </div>
                          {myTeams.order_info.ecommerce_info.ec_tostore_data
                            .ec_tostore_location_name && (
                              <div>
                                <div className="name">店内位置</div>
                                <div className="price">
                                  {
                                    myTeams.order_info.ecommerce_info.ec_tostore_data
                                      .ec_tostore_location_name
                                  }
                                </div>
                              </div>
                            )}
                        </React.Fragment>
                      )
                    )}
                </div>
              </div>
            )}
          {goodsData.goods_list.length > 0 && (
            <div className="collage-section collage-more">
              <div className="title">更多精彩拼团</div>
              <div>
                <div className="goods-list opposite">
                  {goodsData.goods_list.map((item, index) => {
                    return (
                      <div
                        className="goods-item  isRelative"
                        key={index}
                        data-goodsid={item.goods_id}
                        data-activityid={item.activity_id}
                        onClick={this.gotoDetail}
                      >
                        <div className="image-wrap">
                          <img src={item.cover} />
                        </div>
                        <div className="content-wrap">
                          <div className="title">
                            <div className="classify-type">
                              <div>
                                <i className="ico-moon icon-number-people"></i>
                              </div>
                              <span>
                                {item.activity_type == 0
                                  ? item.num_of_people.length > 1
                                    ? '多人团'
                                    : item.num_of_people[0] + '人团'
                                  : item.activity_type == 1
                                    ? '新人团'
                                    : item.activity_type == 2
                                      ? '阶梯团'
                                      : item.activity_type == 3
                                        ? '帮帮团'
                                        : '抽奖团'}
                              </span>
                            </div>
                            {item.title}
                          </div>
                          {item.salesnum ? (
                            <div className="hava-sales">
                              <div className="price">
                                <span className="min-price">
                                  ¥<span>{item.group_buy_price}</span>
                                </span>
                                <span className="origin-price">
                                  {'¥' + item.original_price}
                                </span>
                              </div>
                              <div className="status">
                                <div className="sales">
                                  {'已团' + item.salesnum + '件'}
                                </div>
                                <div className="to-join">
                                  {item.status == 0 ? (
                                    <React.Fragment>
                                      <button className="ready">
                                        即将开团
                                      </button>
                                    </React.Fragment>
                                  ) : item.status == 1 ? (
                                    <React.Fragment>
                                      <button className="remain">提醒我</button>
                                    </React.Fragment>
                                  ) : item.status == 2 ? (
                                    <React.Fragment>
                                      <button className="reminded">
                                        已提醒
                                      </button>
                                    </React.Fragment>
                                  ) : item.status == 3 ? (
                                    <React.Fragment>
                                      <button className="go">去拼团</button>
                                    </React.Fragment>
                                  ) : (
                                            item.status == 4 && (
                                              <React.Fragment>
                                                <button className="over">已结束</button>
                                              </React.Fragment>
                                            )
                                          )}
                                </div>
                              </div>
                            </div>
                          ) : (
                              <div className="no-sales">
                                <div className="price">
                                  <div className="min-price">
                                    ¥<span>{item.group_buy_price}</span>
                                  </div>
                                  <div className="origin-price">
                                    {'¥' + item.original_price}
                                  </div>
                                </div>
                                <div className="to-join">
                                  {item.status == 0 ? (
                                    <React.Fragment>
                                      <button className="ready">即将开团</button>
                                    </React.Fragment>
                                  ) : item.status == 1 ? (
                                    <React.Fragment>
                                      <button className="remain">提醒我</button>
                                    </React.Fragment>
                                  ) : item.status == 2 ? (
                                    <React.Fragment>
                                      <button className="reminded">已提醒</button>
                                    </React.Fragment>
                                  ) : item.status == 3 ? (
                                    <React.Fragment>
                                      <button className="go">去拼团</button>
                                    </React.Fragment>
                                  ) : (
                                            item.status == 4 && (
                                              <React.Fragment>
                                                <button className="over">已结束</button>
                                              </React.Fragment>
                                            )
                                          )}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/gp-order-detail/GpOrderDetail.jsx